export default function (state, val) {
  state.page = 1;
  state.loading = false;
  val.PaymentsList.forEach(i => {
    i.value = i.Id;
    i.label = i.Id;
  });
  state.items = val.PaymentsList.sort((a, b) => {
    if (a.Id > b.Id) return -1;
    if (a.Id < b.Id) return 1;
    return 0;
  });
}